import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoachNav from "./coach_nav";
import Footer from "../../Components/footer";

const CoachDashboard = () => {
	const navigate = useNavigate();
	const [user, setUser] = useState();
	useEffect(() => {
		const storedUser = localStorage.getItem("nguser");

		if (storedUser) {
			const coach = JSON.parse(storedUser);
			setUser(coach);
		} else {
			navigate("/");
		}
	}, []);

	useEffect(() => {
		if (user && user.role !== "coach") {
			console.warn("Non-coach user attempted to access admin dashboard.");
			localStorage.removeItem("nguser");
			navigate("/");
		}
	}, [user, navigate]);

	return (
		<div className="w-screen flex flex-col justify-center items-center relative">
			<CoachNav />
			<main className="w-screen px-4 md:px-20 pt-10 mt-16 lg:mt-20">
				<p className="text-2xl lg:text-5xl font-semibold text-gray-400">
					Welcome
				</p>
				<p className="text-3xl lg:text-7xl font-bold mt-4 lg:mt-8 text-gray-200">
					{user && user.name}
				</p>

				<div className="flex flex-col lg:flex-row lg:justify-around gap-10 mt-10 lg:mt-20">
					<div
						onClick={() => navigate("/coach/assign")}
						className="relative flex justify-center items-end rounded-3xl shadow-lg transition durationn-300 hover:shadow-cyan-500/50 overflow-hidden cursor-pointer w-full h-96"
					>
						<img
							src="/coach_as.jpg"
							alt="Assign Session"
							width={500}
							className="absolute inset-0 w-full h-full object-cover"
						/>
						<p className="absolute bottom-8 z-10 flex items-center justify-center text-white text-4xl md:text-6xl font-bold bg-transparent brightness-70">
							Assign Session
						</p>
					</div>
					<div
						onClick={() => navigate("/coach/registerplyaer")}
						className="relative flex justify-center items-end rounded-3xl shadow-lg transition durationn-300 hover:shadow-cyan-500/50 overflow-hidden cursor-pointer w-full h-96"
					>
						<img
							src="/coach_rp.jpg"
							alt="Register Player"
							width={500}
							className="absolute inset-0 w-full h-full object-cover"
						/>
						<p className="absolute bottom-8 z-10 flex items-center justify-center text-white text-4xl md:text-6xl font-bold bg-transparent">
							Register Player
						</p>
					</div>
				</div>
			</main>
			<Footer />
		</div>
	);
};

export default CoachDashboard;
